import { fromJS, List, Map } from 'immutable'
import React, { Component, Fragment, PureComponent } from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { tokenApi } from '../common/api'
import './content.sass'
import ContentList from './list'
import ContentView from './view'

const processContent = content => {
  if (!Array.isArray(content)) return []

  return fromJS(
    content.map(item => {
      let { materials = [] } = item

      item.materialGroups = materials.reduce(
        (groups, material) => {
          let { file } = material
          let { id, url, meta = {}, filename, access, review_id } = file
          let { type = '', thumbnail, versions } = meta

          let isPublic = access === 'public'

          if (material.type === 'article') {
            isPublic = true
            groups.article.push({
              id,
              filename: file.title,
              content: file.content,
              isPublic,
            })
          } else if (type.includes('video')) {
            groups.video.push({
              id,
              url,
              filename,
              thumbnail: thumbnail,
              poster: thumbnail,
              versions,
              isPublic,
              review: review_id,
            })
          } else if (type.includes('image')) {
            groups.image.push({
              id,
              url,
              filename,
              thumbnail: url,
              previewImage: url,
              isPublic,
            })
          } else {
            groups.other.push({
              id,
              filename,
              url,
              isPublic,
            })
          }

          return groups
        },
        {
          video: [],
          image: [],
          article: [],
          other: [],
        }
      )

      return item
    })
  )
}

export default class ContentRoot extends Component {
  state = {
    loading: true,
    error: false,
    content: List(),
    oldMaterial: null,
  }

  componentDidMount() {
    this.loadContent()
  }

  loadContent = () => {
    return tokenApi.get(this.props.token, '/dashboard/content').then(({ data }) => {
      this.setState({
        loading: false,
        error: !data.success,
        content: processContent(data.content || []),
        oldMaterial: data.oldMaterial,
      })
    })
  }

  render() {
    let { loading, content, error, uploadSuccess, oldMaterial } = this.state
    const { routePrefix, token, t, organizationId } = this.props

    let contentProps = {
      content,
      loadContent: this.loadContent,
      addReviewId: this.addReviewId,
      uploadSuccess,
      oldMaterial,
      routePrefix,
      token,
      organizationId,
      t,
    }

    return (
      <div className="page-content-inner">
        <div className="container">
          {error ? (
            <div className="message message--error">{this.t('error.general')}</div>
          ) : loading ? (
            <div className="loader loader--box">
              <i className="fas fa-spin fa-spinner" />
            </div>
          ) : (
            <Switch>
              <Route
                path={`/yritys/${organizationId}/content/:content_id`}
                render={props => <ContentView {...this.props} {...props} {...contentProps} />}
              />
              <Route
                path={`/yritys/${organizationId}`}
                render={props => <ContentList {...this.props} {...props} {...contentProps} />}
              />
            </Switch>
          )}
        </div>
      </div>
    )
  }
}
